module.exports = __webpack_public_path__ + "assets/img/Quorn-Pillar-Page-Resource.ea799436.webp";